import React, { useState } from 'react';

import FolderIcon from '@material-ui/icons/Folder';
import ArrowRight from '@material-ui/icons/ArrowRight';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';

import { TreeBranch } from './TreeBranch';
import { LibraryItem } from '../../../entities/LibraryItem';
import { List, ListItem, ListItemIcon, ListItemText, Typography, Collapse, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    listItem: {
        borderRadius: "0px 15px 15px 0px",
        '&:hover': {
            backgroundColor: '#F5F5F5'
        },
        paddingRight: "36px",
        paddingTop: "6px",
        paddingBottom: "6px",
        paddingLeft: "12px"
    },
    listItemText: {
        color: "rgb(143, 143, 143)",
        fontWeight: 500,
        fontFamily: "Roboto, Helvetica",
        fontSize: "13px"
    },

    listIcon: {
        marginRight: "0px",
        color: "rgb(143, 143, 143)",
    },
    extraDense: {
        paddingTop: '0px',
        paddingBottom: '0px'
    }
}));

interface Props {
    item: LibraryItem;
    existingFolders: LibraryItem[];
    onSelect: (folderLibraryItemId: string) => void;
    level: number;
    focusedId: string;
}

export function Leaf(props:Props){
    const classes = useStyles();

    const [open, setOpen] = useState(false);

    return (
        <List
            dense
            className={classes.extraDense}
            key={props.item.id}
        >
            <ListItem
                style={{
                    backgroundColor: `${props.focusedId === props.item.id ? "#e8f0fe" : ""}`,
                    paddingLeft: `${props.level * 12}px`
                }}
                className={classes.listItem}
                button
                onClick={() => props.onSelect(props.item.id)}
                onDoubleClick={(e) => setOpen(!open)}
            >
                <ListItemIcon
                    className={classes.listIcon}
                    onClick={(e) => setOpen(!open)}
                >
                    {open ? <ArrowDropDown /> : <ArrowRight />}
                </ListItemIcon>
                <ListItemIcon className={classes.listIcon}>
                    <FolderIcon />
                </ListItemIcon>
                <ListItemText
                    disableTypography
                    style={{
                        paddingLeft: "8px"
                    }}
                    primary={
                        <Typography
                            variant="body1"
                            className={classes.listItemText}
                            style={{
                                color: `${props.focusedId === props.item.id ? "#1967d2" : ""}`
                            }}
                        >
                            {props.item.name}
                        </Typography>
                    }
                />
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <TreeBranch
                    key={props.item.id + props.item.parentId}
                    parentId={props.item.id}
                    folderLibraryItems={props.existingFolders}
                    onSelect={props.onSelect}
                    level={props.level + 1}
                    focusedId={props.focusedId}
                />
            </Collapse>
        </List>
    );
}